// A banner which displays the current environment the application
// is being served from.
//
// @flow

import React from 'react';
import environmentDetection from '../../lib/environmentDetection';
import config from '../../api/config';

const ENVIRONMENTS = {
    ALPHA: 'alpha',
    LOCAL: 'local',
    STAGING: 'staging',
    PRODUCTION: 'production'
};

type Props = {
    children: any
};

export default function(props: Props) {
    const clientEnvironment = environmentDetection();
    const apiEnvironment = config.APP_ENV;

    // If both environments are production then just output the
    // children in a div.
    //
    // If this is not the case, then wrap everything in a container
    // with the banner at the top and the children below.
    if (clientEnvironment.isProduction && config.IS_PRODUCTION) {
        return <div>{props.children}</div>;
    } else {
        const currentClientEnvironment = clientEnvironment.isLocal
            ? ENVIRONMENTS.LOCAL
            : clientEnvironment.isAlpha
                ? ENVIRONMENTS.ALPHA
                : clientEnvironment.isStaging
                    ? ENVIRONMENTS.STAGING
                    : null;

        return (
            <div className="environment-banner-container">
                <div
                    className={`environment-banner ${currentClientEnvironment ||
                        apiEnvironment}`}
                >
                    You are currently using the
                    <span> {currentClientEnvironment} </span>
                    application and pointing to the
                    <span> {apiEnvironment} </span>
                    API.
                </div>
                <div>{props.children}</div>
            </div>
        );
    }
}
